export default "__VITE_ASSET__B8X$PhiE__"